import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/newsArticles';
import { formatDate, splitDate } from '@/utils/format';

const slides = [
  {
    id: 1,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20stylized%20illustration%20of%20a%20traditional%20Chinese%20courtyard%20house%20in%20heavy%20autumn%20rain%20at%20night%2C%20warm%20amber%20lanterns%20glowing%20through%20the%20mist%2C%20deep%20crimson%20wooden%20door%2C%20ivory%20stone%20steps%2C%20elegant%20moody%20film%20poster%20art%2C%20no%20text%2C%20rich%20atmospheric%20shadows&width=1600&height=1000&seq=hero-slide-01&orientation=landscape',
    kicker: '第一集 · 雨夜归来',
    title: '七年之后，她站在了老宅门外',
    description:
      '一封没有署名的信，把林小满带回了顾家。那盏始终没换过的灯还亮着，屋里的人却都学会了沉默。',
    link: '/detail/plot/1',
  },
  {
    id: 2,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20stylized%20scene%20of%20an%20elegant%20East%20Asian%20woman%20standing%20beside%20a%20tall%20window%20in%20an%20old%20villa%20during%20rain%2C%20deep%20crimson%20curtain%2C%20ivory%20walls%2C%20warm%20dim%20light%2C%20quiet%20emotional%20film%20poster%20art%2C%20no%20text%2C%20refined%20moody%20palette%20and%20soft%20grain&width=1600&height=1000&seq=hero-slide-02&orientation=landscape',
    kicker: '第八集 · 姐姐的沉默',
    title: '她签下名字那天，以为自己在保护所有人',
    description:
      '苏婉第一次没有绕弯子。书房的门关上之后，两姐妹之间剩下的只有一串旧钥匙和一句“我以为你会过得更好”。',
    link: '/detail/plot/8',
  },
  {
    id: 3,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20stylized%20spring%20courtyard%20with%20a%20young%20tree%2C%20ivory%20stone%20walls%20and%20deep%20crimson%20door%2C%20delicate%20blossoms%20and%20warm%20sunlight%2C%20elegant%20hopeful%20film%20poster%20art%2C%20no%20text%2C%20serene%20refined%20atmosphere%20with%20soft%20light&width=1600&height=1000&seq=hero-slide-03&orientation=landscape',
    kicker: '第十二集 · 春天来的时候',
    title: '门重新打开，灯一盏一盏亮起来',
    description:
      '老宅的门牌挂回去了，院子中央多了一棵小树。这个家没有变得完美，但终于愿意把话说完。',
    link: '/detail/plot/12',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => window.clearInterval(timer);
  }, []);

  const slide = slides[current];
  const topNews = newsArticles.slice(0, 4);

  return (
    <section className="relative overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        {slides.map((item, index) => (
          <img
            key={item.id}
            src={item.image}
            alt={`${item.kicker} 剧照`}
            className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-1000 ${
              index === current ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/75 to-foreground-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40" />
      </div>

      <div className="relative mx-auto w-full px-4 pb-10 pt-[108px] md:px-8 md:pb-14 md:pt-[140px]">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="flex flex-col justify-between lg:col-span-8">
            <div>
              <div className="flex flex-wrap items-center gap-3 text-xs text-background-50/80">
                <span className="rounded-full border border-accent-400/70 px-3 py-1 text-accent-300">
                  全 12 集 · 都市家庭剧
                </span>
                <span className="tracking-[0.2em] text-background-50/60">FORBIDDEN LOVE · 2026</span>
              </div>

              <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 sm:text-5xl lg:text-[56px]">
                禁止的爱
                <span className="mt-1 block text-accent-300">善良的小姨子</span>
              </h1>

              <div key={slide.id} className="mt-6 max-w-xl animate-fade-up">
                <p className="text-xs tracking-[0.24em] text-accent-300">{slide.kicker}</p>
                <h2 className="mt-2 font-heading text-xl leading-snug text-background-50 md:text-2xl">
                  {slide.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-background-100/80 md:text-[15px]">{slide.description}</p>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={slide.link}
                  className="group flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm text-primary-950 transition-colors hover:bg-accent-400"
                >
                  阅读本集剧情
                  <span className="flex h-4 w-4 items-center justify-center text-sm transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
                <Link
                  to="/category/cast"
                  className="whitespace-nowrap rounded-md border border-background-50/35 px-5 py-3 text-sm text-background-50 transition-colors hover:border-background-50/80 hover:bg-background-50/10"
                >
                  查看演员阵容
                </Link>
              </div>
            </div>

            <div className="mt-8 flex items-center justify-between gap-4 border-t border-background-50/15 pt-5">
              <div className="flex items-center gap-2">
                {slides.map((item, index) => (
                  <button
                    key={item.id}
                    type="button"
                    aria-label={`切换到第 ${index + 1} 张焦点内容`}
                    onClick={() => setCurrent(index)}
                    className={`h-1 rounded-full transition-all ${
                      index === current ? 'w-9 bg-accent-400' : 'w-4 bg-background-50/35 hover:bg-background-50/60'
                    }`}
                  />
                ))}
                <span className="ml-2 text-xs tracking-widest text-background-50/55">
                  {String(current + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  aria-label="上一张"
                  onClick={() => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)}
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors hover:border-background-50/80"
                >
                  <i className="ri-arrow-left-s-line" />
                </button>
                <button
                  type="button"
                  aria-label="下一张"
                  onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors hover:border-background-50/80"
                >
                  <i className="ri-arrow-right-s-line" />
                </button>
              </div>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-50/15 bg-background-50/95 p-5 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-heading text-base text-foreground-900">
                  <span className="h-4 w-[3px] rounded-full bg-primary-600" />
                  最新动态
                </h2>
                <Link
                  to="/category/news"
                  className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
                >
                  全部
                  <i className="ri-arrow-right-s-line" />
                </Link>
              </div>

              <ul className="mt-4 divide-y divide-background-200">
                {topNews.map((article) => {
                  const { month, day } = splitDate(article.date);
                  return (
                    <li key={article.id} className="group py-3 first:pt-0 last:pb-0">
                      <Link to={`/detail/news/${article.id}`} className="flex gap-3">
                        <div className="h-[54px] w-[72px] shrink-0 overflow-hidden rounded-md bg-background-200">
                          <img
                            src={article.image}
                            alt={article.title}
                            title={`${article.title} - 禁止的爱善良的小姨子动态`}
                            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                          />
                        </div>
                        <div className="min-w-0 flex-1">
                          <p className="line-clamp-2 text-[13px] leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                            {article.title}
                          </p>
                          <p className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-400">
                            <span className="text-primary-500">{article.category}</span>
                            <span className="h-2 w-[1px] bg-background-300" />
                            <span>
                              {month}月{day}日
                            </span>
                          </p>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>

              <div className="mt-4 flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5 text-[11px] text-foreground-500">
                <span>更新至 {formatDate(newsArticles[0].date)}</span>
                <span className="flex items-center gap-1 text-accent-700">
                  <i className="ri-live-line" />
                  持续更新
                </span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}